<template>
  <div class='ship-information-item content-container' v-touch:swipeleft="swipeLeft" v-touch:swiperight="swipeRight" id="content-wrapper">
    <div class="header-section">
      <h3>{{ shipInfo.name }}</h3>
      <div id="ship-image">
        <img :src="shipImageLink" alt="Ship Image" v-rjs="2">
      </div>
      <p class="coordinate-string"><b>Latitude</b>: {{ shipInfo.latitude }}</p>
      <p class="coordinate-string"><b>Longitude</b>: {{ shipInfo.longitude }}</p>
      <p class="ship-type"><b>Ship Type</b>: {{ shipInfo.type }}</p>
    </div>
    <div class="bio">
      <p>{{ shipInfo.bio }}</p>
    </div>
    <div class="quote-container">
      <p class="quote-title">
        <a href="https://www.divein.com/about-divein/" target="_blank">Torben Lonne, Editor-In-Chief at DIVE.in:</a>
      </p>
      <p class="quote">{{ shipInfo.quote }}</p>
    </div>
    <div class="cta-container">
      <a v-bind:href="shipInfo.link" target="_blank">
        <div class="cta">
          <p>Find out more ></p>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'shipInformationItem',
    data() {
      return {};
    },
    computed: {
      ...mapGetters('ships', {
        shipInfo: 'currentShipInformation',
        previousShip: 'previousShip',
        shipImageLink: 'shipImageLink',
        currentShip: 'currentShip',
      }),
    },
    methods: {
      swipeLeft() {
        this.$emit('navigate', -1);
      },
      swipeRight() {
        this.$emit('navigate', 1);
      },
    },
  };
</script>

<style lang="scss" scoped>
  a, a:visited, a:active {
    color: #fff;
  }
  .ship-information {
    width: 100%;
    height: 100%;
    background-color: rgba(1,2,1,0.85);
    color: #fff;
    overflow-y: hidden;
    transition: opacity 300ms;
    position: relative;

    &.active {
      opacity: 1;
      pointer-events: all;
    }

    h3 {
      font-size: 25px;
      margin: 0 0 20px;
      font-weight: bold;
      display: inline-block;
      max-width: 55%;
    }

    p {
      font-size: 14px;
      line-height: 23px;
    }

    .coordinate-string {
      margin: 0;
    }
  }

  .content-container {
    width: 80%;
    height: 100%;
    position: relative;
    position: relative;
    margin: 0 auto;
    overflow-y: auto;
    padding: 0 10%;
    vertical-align: middle;
    text-align: left;
  }

  .info-nav {
    cursor: pointer;
    width: 12px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    img {
      width: 100%;
      height: auto;
    }

    &.left {
      img {
        transform: scale(-1);
      }
      left: 2%;
    }

    &.right {
      right: 2%;
    }
  }

  .header-section {
    // display: flex;
    margin-top: 75px;
    .flex-half {
      width: 50%;
      margin-top: 75px;

      img {
        max-width: 100%;
      }
    }
  }

  .cta-container {
    margin: 20px 0 30px;
  }

  .cta {
    color: #fff;
    text-decoration: none;
    background-color: #7dbf72;
    width: auto;
    display: inline-block;
    padding: 7px 20px 10px;
    border-radius: 8px;
    cursor: pointer;
    p {
      color: #fff;
      text-decoration: none;
      margin: 0;
      font-weight: bold;
    }
  }

  .close {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
    width: 31px;
    height: 31px;
    img {
      width: 100%;
      height: auto;
    }
  }

  #forces-stamp {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0.03;
    width: 70%;
    max-width: 323px;
    height: auto;
    pointer-events: none;
  }

  #classified-stamp {
     position: absolute;
     bottom: 10%;
     right: 0;
     width: 100%;
     max-width: 570px;
     pointer-events: none;
     opacity: 0.1;
   }

  #ship-image {
    float: right;
    display: inline-block;
    width: 40%;
    max-width: 300px;
    height: auto;
    img {
      max-width: 100%;
      height: auto;
    }
  }

  .divider {
    position: absolute;
    top: 50%;
    left: 2%;
    transform: translateY(-50%);
    width: 1px;
    height: 72.2%;
    display: none;
    background: #fff;
  }

  .quote-container {
    margin-top: 40px;
  }

  .quote-title {
    font-weight: bold;
  }

  .quote {
    position: relative;
    &:before {
      content: "“";
      color: #fff;
      font-size: 40px;
      position: absolute;
      top: 0;
      left: -25px;
    }

    &:after {
      content: "”";
      color: #fff;
      font-size: 40px;
      position: absolute;
      bottom: -10px;
      right: -20px;
    }
  }

  @media screen and (min-width: 768px) {
    .ship-information {
      position: relative;

      h3 {
        font-size: 42px;
        line-height: 58px;
      }
      p {
        font-size: 18px;
        line-height: 26px;
      }
      .coordinate-string {
        margin: 15px 0;
      }
    }

    .bio {
      margin-top: 70px;
    }

    .content-container {
      display: inline-block;
      position: relative;
      height: auto;
      // top: 50%;
      // left: 50%;
      // transform: translate(-50%, -50%);
    }
  }

  @media screen and (min-width: 992px) {
    .ship-information {
      width: 60%;
      position: absolute;
      left: 40%;
      top: 0;
      pointer-events: all;
      opacity: 1;
      display: block !important;

      h3 {
        font-size: 30px;
      }

      p {
        font-size: 16px;
      }
    }

    .divider {
      display: inline-block;
    }

    .info-nav {
      &.left {
        left: 5%;
      }

      &.right {
        right: 5%;
      }
    }

    .quote {
      position: relative;
      &:before {
        content: "“";
        color: #fff;
        font-size: 60px;
        position: absolute;
        top: 0;
        left: -35px;
      }

      &:after {
        content: "”";
        color: #fff;
        font-size: 60px;
        position: absolute;
        bottom: -10px;
        right: -35px;
      }
    }

    .content-container {
      height: auto;
    }
  }

  @media screen and (min-width: 1200px) {
    .content-container {
      max-width: 800px;
    }

    .ship-information {
      p {
        font-size: 18px;
      }

      h3 {
        font-size: 48px;
      }
    }
  }

  @media screen
    and (min-width: 992px)
    and (max-height: 1000px) {
      .content-container {
        max-height: 100%;
      }
  }

</style>



// WEBPACK FOOTER //
// ShipInformationItem.vue?188e6e9f